import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';
import { NavigationService } from 'app/services/navigation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-revision-request-info',
  templateUrl: './revision-request-info.component.html',
  styleUrls: ['./revision-request-info.component.scss']
})
export class RevisionRequestNameComponent implements OnInit, OnDestroy {
  usanFormType!: string;
  revisionRequestName!: string;
  revisionRequestReason!: string;

  private usanFormTypeSubscription: Subscription;

  constructor(protected navigationService: NavigationService, protected formService: FormService, private responsive: BreakpointObserver) {
    this.usanFormTypeSubscription = this.navigationService.getUsanFormTypeUpdate().subscribe(
      formType => {
        this.usanFormType = formType.value;
      });
    this.usanFormType = this.navigationService.getUsanFormTypeValue();

  }
  
  ngOnInit(): void {
    this.revisionRequestName = this.currentForm.get('revisionRequestName')?.value;
    this.revisionRequestReason = this.currentForm.get('revisionReason')?.value;
  }

  ngOnDestroy(): void {
    this.usanFormTypeSubscription.unsubscribe();
  }

  public clearRevisionRequestNameInputField() {
    this.revisionRequestName = '';
    this.currentForm?.patchValue({'revisionRequestName': ''});
  }

  public updateRevisionRequestName(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.revisionRequestName = '';
      }
    }
    this.formService.updateUsanFormValue('revisionRequestName', this.revisionRequestName);
  }

  public cancelRevisionRequestNameUpdate() {
    this.revisionRequestName = this.currentForm?.get('revisionRequestName')?.value;
  }

  public clearRevisionRequestReasonInputField() {
    this.revisionRequestReason = '';
    this.currentForm?.patchValue({'revisionReason': ''});
  }
  
  public updateRevisionRequestReason(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.revisionRequestReason = '';
      }
    }
    this.formService.updateUsanFormValue('revisionReason', this.revisionRequestReason);
  }

  public cancelRevisionRequestReasonUpdate() {
    this.revisionRequestReason = this.currentForm?.get('revisionReason')?.value;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
